'use client';

import { AlertCircle } from 'lucide-react';
interface NotAvailableProps {
  withIcon?: boolean;
}
export function NotAvailable({
  withIcon = true
}: NotAvailableProps) {
  return <div className="inline-flex gap-2 items-center">
      <span>N/A</span>
      {withIcon && <AlertCircle className="w-4 h-4 text-secondary-readable/[0.5]" />}
    </div>;
}